import React from 'react';

export const BindingLegalList = ({ items, testid }) => (
  <dl className="space-y-4" data-testid={testid}>
    {items.map(([title, body], i) => (
      <div key={title} data-testid={`${testid}-item-${i}`}>
        <dt className="text-sm font-semibold text-gray-200">{title}</dt>
        <dd className="text-sm text-gray-400 leading-relaxed mt-1">{body}</dd>
      </div>
    ))}
  </dl>
);
